module.exports = __webpack_public_path__ + "images/da7d3afa81ca3f0769fb85f58e55b47c.png";